<button
  app-mat-stroked-button
  [color]="color"
  (click)="onButtonClick($event)"
  [disabled]="disabled"
  [style.width]="fullWidth ? '100%' : 'auto'"
>
  <span class="button-spinner" *ngIf="isLoading" [ngClass]="{ 'loading': isLoading }">
    <!-- <mat-spinner diameter='20'></mat-spinner> -->
    <app-loading-spinner [isLoading]="isLoading"></app-loading-spinner>
  </span>
  <span class="original-content" [ngClass]="{ 'loading': isLoading }">
    <ng-content></ng-content>
  </span>
</button>
